module.exports = __webpack_public_path__ + "static/img/end.d6d23f59.png";